<template lang="pug">
  .dashboard-quick-links
    v-card.mx-3.pa-4(flat outlined style="border: 1px solid var(--v-primary200);")
      h6.basic1000--text {{ $t('quick_links') }}
      v-select.mt-4(v-model="form" item-text="name" return-object :items="forms" outlined dense :loading="isFetchingForms" background-color="basic200" hide-details placeholder="Select link to share")
        template(v-slot:append)
          eva-icon(name="chevron-down-outline" width="24" height="24" :fill="$vuetify.theme.themes[$theme].basic700")
        template(v-slot:item="{ index, item, attrs }")
          div.py-2
            div.s1.mb-1(:class="attrs.inputValue ? 'white--text' : 'primary--text'") {{ item.name }}
            div.d-flex
              div.c1.mr-2(:class="attrs.inputValue ? 'white--text' : 'basic600--text'") {{ $t('products') }}: {{ item.products.length }}
              div.c1.mr-2(:class="attrs.inputValue ? 'white--text' : 'basic600--text'") {{ $t('clicks') }}: {{ item.total_clicks }}
              div.c1(:class="attrs.inputValue ? 'white--text' : 'basic600--text'") {{ $t('sales') }}: {{ item.total_sales | displayPrice }}
      v-layout.mt-4
        v-spacer
        v-btn.info500(color='info500' dark depressed height=32 @click="form ?  clickShare() : '' ")
          .button-AA-small.basic100--text {{ $t('share') }}

    .modals(v-if="form")
      embed-form-dialog(v-if="openEmbedDialog" :open.sync="openEmbedDialog" :form.sync="form" :company="company")
      y-dialog.white(v-model='openPrintQR' max-width="400px")
        v-card
          v-row.pt-3(no-gutters align="center")
            v-col(cols="8" offset="2" align="center")
              v-chip(color="black" :to="`/print-qr?link=${form.slug}`" target="_blank" link outlined small)
                | {{ $t('print') }}
                v-icon.ml-2(small) mdi-cloud-print-outline
            v-col.pr-3(cols="2" align="center")
              v-btn(icon small @click="openPrintQR = false; shareSheet = false")
                v-icon mdi-close
          v-card(align="center" flat)
            div.d-flex.justify-center.align-center(style="position: absolute; height: 100%; width: 100%")
              img(:src="require('@/assets/images/icon_yezza_qr.png')" style="width: 75px")
            vue-qrcode(:value="getQRLinkURL()" :options="{ width: 270 }")
      y-bottom-sheet(v-model='shareSheet' inset max-width="600px")
        v-list
          div.pt-2.px-6.s2.primary400--text {{ $t('share_url_by') }}
          v-list-item(@click="shareUrlToSocial('whatsapp')")
            v-list-item-avatar.my-0
              v-icon(color="#455A64" size="24") fab fa-whatsapp
            v-list-item-title.s2.basic1000--text WhatsApp
          v-list-item(@click="shareUrlToSocial('facebook')")
            v-list-item-avatar.my-0
              v-icon(color="#3b5998" size="24") fab fa-facebook
            v-list-item-title.s2.basic1000--text Facebook
          v-list-item(v-if="Auth('root', 'custom_link') && customLinkSlug" @click="copyUrl" v-clipboard:copy="getShareCustomURL()")
            v-list-item-avatar.my-0
              v-icon(size="24") mdi-content-copy
            v-list-item-title.s2.basic1000--text {{ $t('copy_custom_link') }}
              div.c1.primary400--text {{getShareCustomURL()}}
          v-list-item(@click="copyUrl" v-clipboard:copy="getBrandedLinkURL()")
            v-list-item-avatar.my-0
              v-icon(size="24") mdi-content-copy
            v-list-item-title.s2.basic1000--text {{ $t('copy_link') }}
              div.c1.primary400--text {{getBrandedLinkURL()}}
          v-list-item(@click="copyUrl" v-clipboard:copy="getShortLinkURL()")
            v-list-item-avatar.my-0
              v-icon(size="24") mdi-content-copy
            v-list-item-title.s2.basic1000--text {{ $t('copy_short_link') }}
              div.c1.primary400--text {{getShortLinkURL()}}
          v-list-item(@click="openPrintQR = true")
            v-list-item-avatar.my-0
              v-icon(size="24") mdi-qrcode
            v-list-item-title.s2.basic1000--text {{ $t('print_qr_code') }}
          v-list-item(@click="openEmbedDialog = true; shareSheet = false")
            v-list-item-avatar.my-0
              v-icon(size="24") mdi-code-braces
            v-list-item-title.s2.basic1000--text {{ $t('embed_in_website') }}

</template>

<script>
import { mapState, mapActions } from 'vuex'
import VueQrcode from '@chenfengyuan/vue-qrcode'
import EmbedFormDialog from '@/components/dialogs/EmbedFormDialog.vue'

export default {
  name: 'DashboardQuickLinks',
  props: ['company'],
  components: { VueQrcode, EmbedFormDialog },
  data: () => ({
    form: null,
    isFetchingForms: false,
    fetchCount: 100,
    page: 1,
    forms: [],
    openPrintQR: false,
    openEmbedDialog: false,
    shareSheet: false,
    customLinkSlug: null,
    customDomainURL: null
  }),
  computed: {
    ...mapState('user', ['member']),
    linkURL () {
      if (this.customDomainURL) {
        return `https://${this.customDomainURL}/`
      }
      return `https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/`
    }
  },
  watch: {
    shareSheet (val) {
      if (!val) {
        this.customLinkSlug = null
      }
    }
  },
  mounted () {
    this.fetchForms()
    this.fetchDomain()
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
    fetchForms() {
      this.isFetchingForms = true
      let url = `/forms/?page=${this.page}&page_size=${this.fetchCount}&company=${this.company.id}&ordering=-total_sales&type=whatsapp&type=pay_now&type=both&type=donation&status=published`
      if (this.member.role === 'Agent') {
        url += `&agent_member_id=${this.member.id}&members=${this.member.id}`
      }
      this.$axios.get(url)
        .then(resp => {
          if (resp.data.results.length > 0) {
            this.forms = resp.data.results
          }
        })
        .catch(() => {})
        .finally(() => {
          this.isFetchingForms = false
        })
    },
    fetchDomain() {
      this.$axios.get(`/domains/?company=${this.company.id}`)
        .then((response) => {
          let domain = response.data.results.filter(f => f.enabled && f.mode.includes(1))
          if (domain.length > 0) {
            this.customDomainURL = `wasap.${domain[0].name}`
          }
        })
        .catch(() =>{})
    },
    fetchCustomLink () {
      let url = null
      url = this.member.role === 'Agent' ? `member=${this.member.id}` : 'without_member=true'
      this.$axios.get(`/forms/${this.form.id}/slugs/?${url}`)
        .then(resp => {
          if (resp.data.results.length  > 0) {
            this.customLinkSlug = resp.data.results[0].slug
          }
        })
        .catch(() => {})
    },
    getFormURL () {
      return `https://${this.company.slug}.${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}`
    },
    getShareLinkURL () {
      return `WhatsApp Now: ${this.linkURL + this.form.slug}`
    },
    getBrandedLinkURL () {
      return this.linkURL + this.form.slug
    },
    getShareLinkFB () {
      return this.linkURL + this.form.slug
    },
    getShortLinkURL () {
      return `https://${process.env.VUE_APP_SHORT_URL_DOMAIN}/${this.form.slug}`
    },
    getQRLinkURL () {
      return this.linkURL + this.form.slug
    },
    getShareCustomURL () {
      return this.linkURL + this.customLinkSlug
    },
    shareUrlToSocial(platform) {
      if (platform == 'whatsapp') {
        window.open(`https://api.whatsapp.com/send?text=${this.getShareLinkURL()}`, '_blank')
      } else if (platform == 'facebook') {
        window.open(`https://www.facebook.com/sharer/sharer.php?u=${this.getShareLinkFB()}`, '_blank')
      } else if (platform === 'twitter' ) {
        window.open(`http://twitter.com/share?url=${encodeURIComponent(this.getShareLinkURL())}`, '_blank')
      }
    },
    copyUrl() {
      this.showMessage(['success', this.$t('success_message.link_copied_to_clipboard')])
      this.shareSheet = false
    },
    clickShare () {
      this.fetchCustomLink()
      this.shareSheet = true
    },
  }
}
</script>

<style scoped>
.v-text-field--outlined >>> fieldset {
  border-color: var(--v-primary200);
}
.error--text >>> fieldset {
  border-color: var(--v-danger);
}
div >>> .v-list-item--active{
  background-color: var(--v-info500) !important;
  color:white !important;
}
</style>
